<template>
  <b-card>
    <div class="content-box">
      <div class="info-box mb-1">
        <span>拟录用人数:{{ needNum }}；初审通过人数:{{ firstPassNum }}人；
          <span>实际在岗人数:{{ hiredNum }}人；</span>
          当前月工资上限合计{{ monthMoneyCap ? monthMoneyCap : '--' }}元</span>
        <!-- <el-button type="primary"
                 style="float: right"
                 @click="packageUse"
                 v-if="!isShow">批量聘用</el-button> -->
        <div
          v-if="isShow"
          style="margin-top: 15px;font-size: 14px"
        >
          <span>招聘日期: </span>
          <span>{{ startDate | moment('YYYY-MM-DD') }}</span>
          <span>~</span>
          <span>{{ endDate | moment('YYYY-MM-DD') }}</span>
        </div>
      </div>
      <el-row class="mt10">
        <el-col>
          <el-select
            v-model="jobStateValue"
            placeholder="请选择在岗状态"
            clearable
          >
            <el-option
              v-for="item in jobStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            class="ml-1"
            @click="screening"
          >筛选</el-button>
          <el-button
            v-if="!isShow"
            type="primary"
            @click="packageUse"
          >批量聘用</el-button>
        </el-col>
      </el-row>
      <div>
        <el-table
          :data="tableData"
          tooltip-effect="dark"
          class="responsive"
          @selection-change="handleSelectionChange"
        >
          <el-table-responsive-column
            :selectable="selectableFunc"
            type="selection"
            width="55"
          />
          <el-table-responsive-column
            label="序号"
            type="index"
            width="55"
          />
          <el-table-responsive-column
            prop="applicant.realName"
            label="申请人"
          />
          <el-table-responsive-column
            prop="applicant.userName"
            label="学号"
          />
          <el-table-responsive-column
            prop="monthMoneyCap"
            label="月工资上限"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.monthMoneyCap ? scope.row.monthMoneyCap : '无' }}</span>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="申请材料">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="checkOut(scope.row)"
              >查看</el-button>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="面试通知">
            label="面试通知">
            <template slot-scope="scope">
              <div v-if="scope.row.interviewStatus === 'SEND'">
                已发送
              </div>
              <div
                v-else
                style="color: red"
              >
                不发送
              </div>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="面试结果">
            <template slot-scope="scope">
              <span v-if="scope.row.interviewResult === 'PASS'">通过</span>
              <span
                v-else
                style="color: red;"
              >不通过</span>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column
            :show-overflow-tooltip="true"
            prop="interviewAssessment"
            label="面试评价"
            width="100"
          />
          <el-table-responsive-column
            prop="applicationStatus"
            label="上岗状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.applicationStatus === 'FIRED'">已解聘</span>
              <span v-else-if="scope.row.applicationStatus === 'WORKING'">工作中</span>
              <span v-else-if="scope.row.applicationStatus === 'NONE'">初始</span>
              <span v-else-if="scope.row.applicationStatus === 'FAIL'">拒绝</span>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.checkStatus === 1 && !isShow">
                <el-button
                  type="text"
                  @click="useIt(scope.row)"
                >聘用</el-button>
                <el-button
                  type="text"
                  style="color: red"
                  @click="noUseIt(scope.row)"
                >不聘用</el-button>
              </div>
              <div v-else>
                <span>{{ unitStatus(scope.row.checkStatus) }}</span>
              </div>
            </template>
          </el-table-responsive-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          :current-page="currentPage + 1"
          :page-size="sizePage"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next"
          :total="totalSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <div class="dialog-box">
        <!-- 聘用 -->
        <normalDialog
          ref="normalDialog"
          :is-warning="false"
          title-word="审核"
          inner-info="是否确定聘用该生？"
          :com-firm-btn="useItComfirm"
        />
        <!--不聘用-->
        <normalDialog
          ref="warningDialog"
          title-word="审核"
          inner-info="是否确定不聘用该生？"
          :com-firm-btn="noUseItComfirm"
        />
        <!-- 批量聘用 -->
        <normalDialog
          ref="packageDialog"
          title-word="审核"
          :is-warning="false"
          :inner-info="packageInnerInfo"
          :com-firm-btn="packageComfirm"
        />
        <!-- 申请材料弹框 -->
        <applicationMaterial
          ref="applicationMaterials"
          :application-data="applicationData"
          :info-obj="infoObj"
        />
      </div>
    </div>
  </b-card>
</template>
<script>
import { applicationService } from '@/api/index'
import { unitStatus } from '@/tool/utils'
import normalDialog from '@/components/WarningDialog.vue'
import applicationMaterial from '@/components/ApplicationMaterials.vue'

export default {
  name: 'WorkAssistant', // 工作助理
  components: {
    normalDialog,
    applicationMaterial,
  },
  data() {
    return {
      id: null,
      tableData: [],
      currentPage: 0,
      sizePage: 10,
      totalSize: 0,
      monthMoneyCap: null,
      hiredNum: null,
      choosePersons: [], // 被选中的人
      packageInnerInfo: '',
      choosePersonId: null,
      applicationData: null,
      needNum: '',
      firstPassNum: null,
      isShow: false,
      startDate: '',
      endDate: '',
      infoObj: null,
      jobStateValue: '',
      jobStateOptions: [
        {
          value: 0,
          label: '初始',
        },
        {
          value: 1,
          label: '拒绝',
        },
        {
          value: 2,
          label: '工作中',
        },
        {
          value: 3,
          label: '已解聘',
        },
      ],
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    unitStatus,
    initPage() {
      this.needNum = this.$route.query.needNum
      this.isShow = this.$route.query.show
      this.startDate = Number(this.$route.query.start)
      this.endDate = Number(this.$route.query.end)
      this.queryTable()
    },
    queryTable() {
      this.id = this.$route.query.id
      const params = {
        applicationStatus: this.jobStateValue,
        jobId: this.id,
        page: this.currentPage,
        size: this.sizePage,
        type: 2, // 1单位， 2学工
      }
      applicationService()._studentCheckList(params).then(res => {
        if (res.status) {
          this.tableData = res.data.res.content
          this.totalSize = res.data.res.totalElements
          this.monthMoneyCap = res.data.monthMoneyCap
          this.hiredNum = res.data.hiredNum
          this.firstPassNum = res.data.firstPassNum
        }
      })
    },
    handleSelectionChange(arr) {
      this.choosePersons = arr
    },
    useIt(row) {
      this.choosePersonId = row.id
      this.$refs.normalDialog.dialogVisible = true
    },
    useItComfirm() {
      const params = [{
        applicationId: this.choosePersonId,
        checkStatus: 2,
      }]
      applicationService()._schoolCheck(params).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.$refs.normalDialog.dialogVisible = false
          this.queryTable()
        }
      })
    },
    noUseIt(row) {
      this.choosePersonId = row.id
      this.$refs.warningDialog.dialogVisible = true
    },
    noUseItComfirm() {
      const params = [{
        applicationId: this.choosePersonId,
        checkStatus: 3,
      }]
      applicationService()._schoolCheck(params).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.$refs.warningDialog.dialogVisible = false
          this.queryTable()
        }
      })
    },
    // 批量聘用
    // eslint-disable-next-line consistent-return
    packageUse() {
      if (this.choosePersons.length === 0) {
        this.$message.warning('请选择学生')
        return false
      }
      this.packageInnerInfo = `是否批量聘用当前选择的${this.choosePersons.length}名学生？`
      this.$refs.packageDialog.dialogVisible = true
    },
    // 批量聘用确定
    packageComfirm() {
      const params = []
      this.choosePersons.forEach(x => {
        const i = {
          checkStatus: 2,
          applicationId: x.id,
        }
        params.push(i)
      })
      applicationService()._schoolCheck(params).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.$refs.packageDialog.dialogVisible = false
          this.queryTable()
        }
      })
    },
    // 查看申请材料
    checkOut(row) {
      const params = {
        study: row.study,
        work: row.work,
        economic: row.economic,
        cognition: row.cognition,
        hobbies: row.hobbies,
        items: JSON.parse(row.schedule),
      }
      this.infoObj = row.applicant
      const bankInfo = {
        bankNoDefault: row.bankNoDefault,
        bankNo: row.bankNo,
        bankName: row.bankName,
        defaultBankNo: row.defaultBankNo,
      }
      Object.assign(this.infoObj, bankInfo, { subsidyList: row.subsidyList }, { salaryList: row.salaryList })
      this.applicationData = params
      this.$refs.applicationMaterials.dialogVisible = true
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.queryTable()
    },
    handleSizeChange(val) {
      this.sizePage = val
      this.queryTable()
    },
    selectableFunc(row) {
      if ((row.applicationStatus === 'NONE' && row.checkStatus !== 3 && row.checkStatus !== 2)) {
        return true
      }
      return false

      // return row.applicationStatus === 'NONE'
    },
    // 筛选
    screening() {
      this.queryTable()
    },
  },
}
</script>

<style scoped lang="less">
</style>
